import PropTypes from 'prop-types';
import SelectionPage from '@cont/OfflineCentres/CitySelection/SelectionPage';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import useOfflineCentresStore from '@stores/offline-centres';
import getOfflineCentrePlans from '@cms/api';
import { getOfflineCentrePlansEndpoint } from '@cont/OfflineCentres/apiHelper';
import { getStaticData, getCities } from '@api/fetchers/offline-centres';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const CentreSelectionPage = ({
  cmsData,
  cities,
  offlineCentrePlans,
  defaultCity
}) => {
  return (
    <>
      <SelectionPage
        cmsData={cmsData}
        cities={cities}
        offlineCentrePlans={offlineCentrePlans}
        defaultCity={defaultCity}
      />
    </>
  );
};

CentreSelectionPage.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    hideNudges: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true,
    hideFooter: true
  }
};

CentreSelectionPage.getInitialProps = setupInitialProps(
  async ({ query, store }) => {
    try {
      const defaultCity = query.id ? query.id[0] : null;

      const promises = [];
      let { cmsData, cities } = useOfflineCentresStore.getState();
      if (!cmsData)
        promises.push(
          getStaticData().then((cmsResult) => {
            cmsData = cmsResult;
          })
        );
      if (!cities)
        promises.push(
          getCities().then((citiesResult) => {
            cities = citiesResult;
          })
        );
      const accessToken = store.getState()?.auth?.accessToken;
      let offlineCentrePlans = null;
      if (defaultCity) {
        promises.push(
          getOfflineCentrePlans(
            getOfflineCentrePlansEndpoint(defaultCity),
            false,
            accessToken
          ).then((plans) => {
            offlineCentrePlans = plans;
          })
        );
      }

      await Promise.all(promises);

      useOfflineCentresStore.setState({ cmsData, cities });

      return {
        cmsData,
        cities,
        offlineCentrePlans,
        defaultCity
      };
    } catch (err) {
      return {};
    }
  },
  CentreSelectionPage.pageInfo
);

CentreSelectionPage.Layout = Layout;
CentreSelectionPage.Layout.displayName = 'offlineCentresSelection';

CentreSelectionPage.Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default CentreSelectionPage;
CentreSelectionPage.Wrapper = PageReduxProvider;
